import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { 
  FaArrowLeft, FaUniversity, 
  FaCheck, FaTimes, FaArrowRight, FaExternalLinkAlt, 
  FaExchangeAlt, FaEdit, FaExclamationTriangle, 
  FaIdCard
} from "react-icons/fa";
// 1. استدعاء دوال الـ API الجديدة هنا
import { getRequestDetailsAPI, acceptRequestAPI, rejectRequestAPI } from "../../services/userService"; 
import "../../assets/styles/RequestDetails.css"; 

const RequestDetailsPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type"); 
  const navigate = useNavigate();

  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  // === Modal State ===
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState(null); // 'approve' | 'reject'
  // 2. ستيت جديد لتحميل زرار الاكشن
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await getRequestDetailsAPI(id, type);
        if (response.data) {
          setRequest(response.data);
        }
      } catch (error) {
        console.error("Failed to load details", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [id, type]);

  const handleGoToProfile = () => {
    if (request?.requester?.id) navigate(`/admin/view-user-profile/${request.requester.id}`);
  };

  const triggerAction = (action) => {
    setActionType(action);
    setShowModal(true);
  };

  // 3. الدالة المعدلة للربط مع الباك إند
  const handleConfirmAction = async () => {
    setActionLoading(true); // تشغيل اللودر
    try {
      if (actionType === 'approve') {
        // نداء API القبول
        await acceptRequestAPI(id, type);
      } else {
        // نداء API الرفض
        await rejectRequestAPI(id, type);
      }
      
      setShowModal(false);
      navigate(-1); // العودة للصفحة السابقة
    } catch (error) {
      console.error(`Failed to ${actionType} request:`, error);
      // يفضل هنا عرض Toast Error للمستخدم
      // toast.error(error.response?.data?.message || "Operation failed");
    } finally {
      setActionLoading(false); // إيقاف اللودر في كل الحالات
    }
  };

  if (loading) return <div className="d-flex justify-content-center py-5"><div className="spinner-border text-primary"></div></div>;
  if (!request) return <div className="text-center py-5">Request not found.</div>;

  return (
    <div className="details-container py-4" style={{ marginTop: "60px" }}>
      <div className="container">
        
        {/* Header */}
        <div className="d-flex align-items-center gap-3 mb-4">
          <button onClick={() => navigate(-1)} className="btn btn-white shadow-sm rounded-circle" style={{width: 40, height: 40}}>
            <FaArrowLeft color="#333" />
          </button>
          <div className="flex-grow-1">
             <h5 className="fw-bold mb-0 text-dark">Request Details</h5>
             <span className="text-muted" style={{fontSize: '0.85rem'}}># {request.requester.universityID || "N/A"}</span>
          </div>
          {/* <span style={{fontSize:"15px"}} className={`rounded-pill px-2 py-1 ${request.status === 'pending' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
            {request.status}
          </span> */}
        </div>

        <div className="row g-4">
          {/* Left Column */}
          <div className="col-12 col-lg-8">
            {/* Comparison Card */}
            <div className="detail-card">
              <div className="card-title-custom">
                {type === "roles" ? <FaExchangeAlt className="text-primary" /> : <FaEdit className="text-primary" />}
                {type === "roles" ? "Role Change" : "Profile Update"}
              </div>
              
              <div className="p-3 p-md-4">
                <div className="comparison-container">
                  {type === "roles" ? (
                    <div className="comparison-row">
                      <div className="flex-grow-1">
                         <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>Current Role</small>
                         <div className="val-box val-old">{request.details.fromRole}</div>
                      </div>
                      <FaArrowRight className="arrow-icon" />
                      <div className="flex-grow-1">
                         <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>New Role</small>
                         <div className="val-box val-new">{request.details.toRole}</div>
                      </div>
                    </div>
                  ) : (
                    <div>
                       <div className="text-center mb-3">
                          <span className="badge bg-primary bg-opacity-10 text-primary">Field: {request.details.fieldToUpdate}</span>
                       </div>
                       <div className="comparison-row">
                          <div className="flex-grow-1">
                             <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>Old Value</small>
                             <div className="val-box val-old">{request.details.oldValue || "Empty"}</div>
                          </div>
                          <FaArrowRight className="arrow-icon" />
                          <div className="flex-grow-1">
                             <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>New Value</small>
                             <div className="val-box val-new">{request.details.newValue}</div>
                          </div>
                       </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Reason Card */}
            <div className="detail-card">
               <div className="card-title-custom">Reason</div>
               <div className="p-3 p-md-4 pt-0">
                  <p className="mb-0 text-secondary" style={{lineHeight: '1.6'}}>"{request.details.reason}"</p>
                  
                  {type === "roles" && request.details.rejectionCount > 0 && (
                    <div className="mt-3 alert alert-danger d-flex align-items-center gap-2 m-0 py-2">
                       <FaExclamationTriangle />
                       <small>Rejected {request.details.rejectionCount} times before.</small>
                    </div>
                  )}
               </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-12 col-lg-4">
            <div className="detail-card user-info-card">
               <img src={request.requester.avatar || "/avatars/MALE_avatar.png"} alt="User" className="user-avatar-lg" />
               <h5 className="fw-bold mb-1 text-dark">{request.requester.name}</h5>
               <p className="text-muted small">{request.requester.email}</p>

               <div className="info-list">
                  <div className="info-item">
                     <FaIdCard className="text-primary" />
                     <span className="small fw-bold">{request.requester.universityID || "NA"}</span>
                  </div>
                  <div className="info-item">
                     <FaUniversity className="text-primary" />
                     <span className="small fw-bold">{request.requester.faculty || "N/A"}</span>
                  </div>
               </div>

               <button onClick={handleGoToProfile} className="btn-visit-profile d-flex align-items-center justify-content-center gap-2">
                  View Profile <FaExternalLinkAlt size={12} />
               </button>
            </div>

            {/* Desktop Actions (Hidden on Mobile) */}
            <div className="detail-card p-3 desktop-actions-card">
               <div className="d-flex gap-2">
                  <button onClick={() => triggerAction('reject')} className="btn-action btn-reject w-100">Reject</button>
                  <button onClick={() => triggerAction('approve')} className="btn-action btn-approve w-100">Approve</button>
               </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MOBILE STICKY FOOTER ================= */}
      <div className="mobile-sticky-actions">
         <button onClick={() => triggerAction('reject')} className="btn-action btn-reject">
            <FaTimes /> Reject
         </button>
         <button onClick={() => triggerAction('approve')} className="btn-action btn-approve">
            <FaCheck /> Approve
         </button>
      </div>

      {/* ================= CONFIRMATION MODAL ================= */}
      {showModal && (
        <div className="custom-modal-overlay">
           <div className="custom-modal">
              <div 
                className="modal-icon-circle" 
                style={{
                   backgroundColor: actionType === 'approve' ? '#dcfce7' : '#fee2e2',
                   color: actionType === 'approve' ? '#16a34a' : '#dc2626'
                }}
              >
                 {actionType === 'approve' ? <FaCheck /> : <FaTimes />}
              </div>
              
              <h5 className="fw-bold mb-2 text-dark">
                 {actionType === 'approve' ? 'Approve Request?' : 'Reject Request?'}
              </h5>
              <p className="text-muted small mb-4">
                 Are you sure you want to {actionType} this request? This action cannot be undone.
              </p>

              <div className="modal-btns">
                 <button 
                   className="btn btn-light flex-grow-1 fw-bold"
                   onClick={() => setShowModal(false)}
                   disabled={actionLoading} // تعطيل زر الإلغاء أثناء التحميل
                 >
                   Cancel
                 </button>
                 
                 {/* 4. تعديل زر التأكيد لإظهار اللودر */}
                 <button 
                   className="btn flex-grow-1 fw-bold text-white d-flex justify-content-center align-items-center"
                   style={{
                      backgroundColor: actionType === 'approve' ? '#16a34a' : '#dc2626',
                      opacity: actionLoading ? 0.7 : 1
                   }}
                   onClick={handleConfirmAction}
                   disabled={actionLoading} // تعطيل الزر أثناء التحميل لمنع التكرار
                 >
                   {actionLoading ? (
                     <>
                       <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                       Processing...
                     </>
                   ) : (
                     "Confirm"
                   )}
                 </button>
              </div>
           </div>
        </div>
      )}
    </div>
  );
};

export default RequestDetailsPage;

// import React, { useEffect, useState } from "react";
// import { useParams, useSearchParams, useNavigate } from "react-router-dom";
// import { 
//   FaArrowLeft, FaUniversity, 
//   FaCheck, FaTimes, FaArrowRight, FaExternalLinkAlt, 
//   FaExchangeAlt, FaEdit, FaExclamationTriangle, 
//   FaIdCard
// } from "react-icons/fa";
// import { getRequestDetailsAPI } from "../../services/userService"; // تأكد من استدعاء API الرد (Approve/Reject)
// import "../../assets/styles/RequestDetails.css"; 

// const RequestDetailsPage = () => {
//   const { id } = useParams();
//   const [searchParams] = useSearchParams();
//   const type = searchParams.get("type"); 
//   const navigate = useNavigate();

//   const [request, setRequest] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // === Modal State ===
//   const [showModal, setShowModal] = useState(false);
//   const [actionType, setActionType] = useState(null); // 'approve' | 'reject'

//   useEffect(() => {
//     const fetchDetails = async () => {
//       try {
//         const response = await getRequestDetailsAPI(id, type);
//         if (response.data) {
//           setRequest(response.data);
//         }
//       } catch (error) {
//         console.error("Failed to load details", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchDetails();
//   }, [id, type]);

//   const handleGoToProfile = () => {
//     if (request?.requester?.id) navigate(`/admin/view-user-profile/${request.requester.id}`);
//   };

//   // 1. فتح المودال
//   const triggerAction = (action) => {
//     setActionType(action);
//     setShowModal(true);
//   };

//   // 2. تنفيذ الأكشن (API Call)
//   const handleConfirmAction = async () => {
//     try {
//       // هنا هتنادي على ال API بتاعتك للقبول أو الرفض
//       // await updateRequestStatusAPI(id, actionType);
      
//       console.log(`Request ${id} has been ${actionType}ed`);
//       setShowModal(false);
//       navigate(-1); // رجوع للصفحة السابقة بعد النجاح
//     } catch (error) {
//       console.error(error);
//       // toast.error("Something went wrong");
//     }
//   };

//   if (loading) return <div className="d-flex justify-content-center py-5"><div className="spinner-border text-primary"></div></div>;
//   if (!request) return <div className="text-center py-5">Request not found.</div>;

//   return (
//     <div className="details-container py-4" style={{ marginTop: "60px" }}>
//       <div className="container">
        
//         {/* Header */}
//         <div className="d-flex align-items-center gap-3 mb-4">
//           <button onClick={() => navigate(-1)} className="btn btn-white shadow-sm rounded-circle" style={{width: 40, height: 40}}>
//             <FaArrowLeft color="#333" />
//           </button>
//           <div className="flex-grow-1">
//              <h5 className="fw-bold mb-0 text-dark">Request Details</h5>
//              <span className="text-muted" style={{fontSize: '0.85rem'}}># {request.requester.universityID}</span>
//           </div>
//           <span className={`badge rounded-pill px-3 py-2 ${request.status === 'pending' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
//             {request.status}
//           </span>
//         </div>

//         <div className="row g-4">
//           {/* Left Column */}
//           <div className="col-12 col-lg-8">
//             {/* Comparison Card */}
//             <div className="detail-card">
//               <div className="card-title-custom">
//                 {type === "roles" ? <FaExchangeAlt className="text-primary" /> : <FaEdit className="text-primary" />}
//                 {type === "roles" ? "Role Change" : "Profile Update"}
//               </div>
              
//               <div className="p-3 p-md-4">
//                 <div className="comparison-container">
//                   {type === "roles" ? (
//                     <div className="comparison-row">
//                       <div className="flex-grow-1">
//                          <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>Current Role</small>
//                          <div className="val-box val-old">{request.details.fromRole}</div>
//                       </div>
//                       <FaArrowRight className="arrow-icon" />
//                       <div className="flex-grow-1">
//                          <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>New Role</small>
//                          <div className="val-box val-new">{request.details.toRole}</div>
//                       </div>
//                     </div>
//                   ) : (
//                     <div>
//                        <div className="text-center mb-3">
//                           <span className="badge bg-primary bg-opacity-10 text-primary">Field: {request.details.fieldToUpdate}</span>
//                        </div>
//                        <div className="comparison-row">
//                           <div className="flex-grow-1">
//                              <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>Old Value</small>
//                              <div className="val-box val-old">{request.details.oldValue || "Empty"}</div>
//                           </div>
//                           <FaArrowRight className="arrow-icon" />
//                           <div className="flex-grow-1">
//                              <small className="text-secondary d-block mb-2 text-uppercase fw-bold" style={{fontSize:'0.7rem'}}>New Value</small>
//                              <div className="val-box val-new">{request.details.newValue}</div>
//                           </div>
//                        </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Reason Card */}
//             <div className="detail-card">
//                <div className="card-title-custom">Reason</div>
//                <div className="p-3 p-md-4 pt-0">
//                   <p className="mb-0 text-secondary" style={{lineHeight: '1.6'}}>"{request.details.reason}"</p>
                  
//                   {type === "roles" && request.details.rejectionCount > 0 && (
//                     <div className="mt-3 alert alert-danger d-flex align-items-center gap-2 m-0 py-2">
//                        <FaExclamationTriangle />
//                        <small>Rejected {request.details.rejectionCount} times before.</small>
//                     </div>
//                   )}
//                </div>
//             </div>
//           </div>

//           {/* Right Column */}
//           <div className="col-12 col-lg-4">
//             <div className="detail-card user-info-card">
//                <img src={request.requester.avatar || "/avatars/MALE_avatar.png"} alt="User" className="user-avatar-lg" />
//                <h5 className="fw-bold mb-1 text-dark">{request.requester.name}</h5>
//                <p className="text-muted small">{request.requester.email}</p>

//                <div className="info-list">
//                   <div className="info-item">
//                      <FaIdCard className="text-primary" />
//                      <span className="small fw-bold">{request.requester.universityID || "NA"}</span>
//                   </div>
//                   <div className="info-item">
//                      <FaUniversity className="text-primary" />
//                      <span className="small fw-bold">{request.requester.faculty || "N/A"}</span>
//                   </div>
//                </div>

//                <button onClick={handleGoToProfile} className="btn-visit-profile d-flex align-items-center justify-content-center gap-2">
//                   View Profile <FaExternalLinkAlt size={12} />
//                </button>
//             </div>

//             {/* Desktop Actions (Hidden on Mobile) */}
//             <div className="detail-card p-3 desktop-actions-card">
//                <div className="d-flex gap-2">
//                   <button onClick={() => triggerAction('reject')} className="btn-action btn-reject w-100">Reject</button>
//                   <button onClick={() => triggerAction('approve')} className="btn-action btn-approve w-100">Approve</button>
//                </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ================= MOBILE STICKY FOOTER ================= */}
//       <div className="mobile-sticky-actions">
//          <button onClick={() => triggerAction('reject')} className="btn-action btn-reject">
//             <FaTimes /> Reject
//          </button>
//          <button onClick={() => triggerAction('approve')} className="btn-action btn-approve">
//             <FaCheck /> Approve
//          </button>
//       </div>

//       {/* ================= CONFIRMATION MODAL ================= */}
//       {showModal && (
//         <div className="custom-modal-overlay">
//            <div className="custom-modal">
//               <div 
//                 className="modal-icon-circle" 
//                 style={{
//                    backgroundColor: actionType === 'approve' ? '#dcfce7' : '#fee2e2',
//                    color: actionType === 'approve' ? '#16a34a' : '#dc2626'
//                 }}
//               >
//                  {actionType === 'approve' ? <FaCheck /> : <FaTimes />}
//               </div>
              
//               <h5 className="fw-bold mb-2 text-dark">
//                  {actionType === 'approve' ? 'Approve Request?' : 'Reject Request?'}
//               </h5>
//               <p className="text-muted small mb-4">
//                  Are you sure you want to {actionType} this request? This action cannot be undone.
//               </p>

//               <div className="modal-btns">
//                  <button 
//                    className="btn btn-light flex-grow-1 fw-bold"
//                    onClick={() => setShowModal(false)}
//                  >
//                    Cancel
//                  </button>
//                  <button 
//                    className="btn flex-grow-1 fw-bold text-white"
//                    style={{
//                       backgroundColor: actionType === 'approve' ? '#16a34a' : '#dc2626'
//                    }}
//                    onClick={handleConfirmAction}
//                  >
//                    Confirm
//                  </button>
//               </div>
//            </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RequestDetailsPage;